"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ObjectivesClient_1 = require("client/ObjectivesClient");
const useJira_1 = __importDefault(require("hooks/useJira"));
const HelperUtils_1 = require("utils/HelperUtils");
const caseConverter_1 = require("utils/caseConverter");
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const ListEmptyState_1 = __importDefault(require("components/shared/ListEmptyState"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const RowJira_1 = __importDefault(require("./RowJira"));
const TableConnectJira = ({ searchValue, isShowChildIssue }) => {
    const selectedData = (0, useJira_1.default)((state) => state.selectedData);
    const additionalParams = (0, useJira_1.default)((state) => state.additionalParams);
    const jiraData = (0, useJira_1.default)((state) => state.jiraData);
    const setJiraData = (0, useJira_1.default)((state) => state.setJiraData);
    const isProjectSelected = selectedData == 'project';
    const fetchJIRA = (pageParam) => {
        const params = Object.assign(Object.assign(Object.assign(Object.assign({}, (!isShowChildIssue && { q: searchValue })), { state: [] }), (pageParam && { older_than: pageParam })), (isShowChildIssue && additionalParams));
        return isProjectSelected && !isShowChildIssue
            ? (0, ObjectivesClient_1.getJIRAProjects)(params)
            : (0, ObjectivesClient_1.getJIRAIssues)(params);
    };
    const { hasNextPage, fetchNextPage, isFetchingNextPage, isFetching } = (0, react_query_1.useInfiniteQuery)(['objective', 'jira', selectedData, searchValue], ({ pageParam }) => fetchJIRA(pageParam), {
        getNextPageParam: (lastPage) => { var _a, _b; return (_b = (_a = lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.older_than; },
        enabled: !(0, isEmpty_1.default)(selectedData),
        onSuccess: (data) => {
            var _a;
            const jiras = (0, flatten_1.default)((_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.map((page) => {
                var _a;
                return (_a = page === null || page === void 0 ? void 0 : page.data) === null || _a === void 0 ? void 0 : _a.map((d) => {
                    const clonedData = (0, caseConverter_1.toCamelCase)((0, cloneDeep_1.default)(d));
                    clonedData.data = d.data;
                    return clonedData;
                });
            }));
            setJiraData(jiras);
        }
    });
    const scrollParent = (e) => {
        const loadMore = () => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchNextPage();
        });
        const target = e.target;
        const cond = target.scrollTop + target.clientHeight == target.scrollHeight;
        if (hasNextPage && !isFetchingNextPage && cond) {
            loadMore();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isFetching && !isFetchingNextPage ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (jiraData === null || jiraData === void 0 ? void 0 : jiraData.length) > 0 ? (react_1.default.createElement("div", { className: "overflow-y-auto h-[252px]", onScroll: (e) => scrollParent(e) }, jiraData === null || jiraData === void 0 ? void 0 : jiraData.map((jira) => {
            var _a;
            return (react_1.default.createElement(RowJira_1.default, { jira: jira, key: (_a = jira === null || jira === void 0 ? void 0 : jira.data) === null || _a === void 0 ? void 0 : _a.id, isShowChildIssue: isShowChildIssue }));
        }))) : (react_1.default.createElement(ListEmptyState_1.default, { emptyIcon: "icon-no-objective", size: "small", title: (0, HelperUtils_1.getObjectiveLocale)(`No ${selectedData} found`), containerClassname: "my-[8px]", fullHeight: true })),
        isFetching && isFetchingNextPage && react_1.default.createElement(LoadingComponent_1.default, null)));
};
const TableConnectWrapperJira = ({ searchValue, isShowChildIssue }) => {
    const selectedData = (0, useJira_1.default)((state) => state.selectedData);
    const isProjectSelected = selectedData == 'project';
    const numberHeader = (0, react_1.useMemo)(() => [
        {
            name: '',
            widthClass: 'w-[56px]'
        }
    ], []);
    const defaultHeaders = (0, react_1.useMemo)(() => [
        { name: 'Name', widthClass: 'w-[288px]', grow: true },
        { name: 'Key', widthClass: 'w-[120px]', grow: false },
        { name: 'Type', widthClass: 'w-[180px]', grow: false },
        {
            name: isProjectSelected ? 'Leader' : 'Assignee',
            widthClass: 'w-[260px]',
            grow: false
        }
    ], [isProjectSelected]);
    return (react_1.default.createElement(Table_1.default, { headers: [...(isShowChildIssue ? [] : numberHeader), ...defaultHeaders], useOverflowTable: false, customClassHeader: "!min-h-[36px] border-solid border-0 border-n-400 border-t" },
        react_1.default.createElement(TableConnectJira, { searchValue: searchValue, isShowChildIssue: isShowChildIssue })));
};
exports.default = TableConnectWrapperJira;
